import React from 'react';
import PropTypes from 'prop-types';
import { StepConnector as MuiStepConnector } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { capitalize } from '@mui/material/utils';

const useStyles = makeStyles()((theme, _params, classes) => ({
  active: {},
  completed: {},
  root: {
    [`&.colorWhite .${classes.line}`]: {
      borderColor: theme.palette.custom.white,
    },
    [`&.colorGray .${classes.line}`]: {
      borderColor: theme.palette.text.secondary,
    },
    [`&.colorDefault .${classes.line}`]: {
      borderColor: theme.palette.primary.main,
    },
  },
  line: {
    borderColor: theme.palette.primary.main,
    borderRadius: 1,
    [theme.breakpoints.down('md')]: {
      borderRadius: 0,
    },
  },
  lineHorizontal: {
    borderTopWidth: 2,
  },
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 10px)',
    right: 'calc(50% + 10px)',
  },
}));

function StepConnector({ className, color = 'default', ...props }) {
  const { classes, cx } = useStyles(props, {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    props,
  });
  return <MuiStepConnector {...props} className={cx(`color${capitalize(color)}`, className)} classes={classes} />;
}

StepConnector.muiName = 'StepConnector';

StepConnector.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf(['default', 'white', 'gray']),
};

export default StepConnector;
